<div class="background">
  <ng-lottie [options]="options" [styles]="styles"> </ng-lottie>
</div>
